import React from 'react';
import { Grid, Button } from '@material-ui/core';

import { SearchStatus } from '../enum/SearchStatus';

interface ISearchButtonsProps {
    searchStatus: SearchStatus,
    handleCleanFilter: () => void,
    handleSearch: () => void
}

export function SearchButtons({searchStatus, handleCleanFilter, handleSearch}: ISearchButtonsProps) {
    
    return (
        <Grid item xs={12}>
            <Grid 
                container
                spacing={1}
                direction="row"
                justify="flex-end"
                alignItems="flex-end">
                <Grid item>
                    <Button
                        onClick={handleCleanFilter}
                        size='large'
                        disabled={searchStatus == SearchStatus.LOADING}>
                        LIMPAR FILTROS
                    </Button>
                </Grid>
                <Grid item>
                    <Button 
                        onClick={ handleSearch }
                        variant='contained'
                        color='primary' 
                        size='large' 
                        disabled={searchStatus == SearchStatus.LOADING }>
                            BUSCAR
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
}